import Api from "./Api";
import axios from "axios";
import { BASEURL } from "@/config/index";
import { orderBy } from "lodash";
import { createQueryString } from "./ApiHelper";
export default {
  GetBudgetListByCinema(payload) {
    let qs = createQueryString(payload);

    return Api().get(`/api/budget/get-budget-tracker-list/${qs}`);
  },
  addEditBudget(payload) {
    return Api().post(`/api/budget/add-budget-tracker`, payload);
  },
  getBudgetReport(payload) {
    return Api().post(`/api/budget/get-budget-report`, payload);
  }
};



// WEBPACK FOOTER //
// ./src/services/BudgetService.js